import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `Tile`
};

export function useTileStyles() {
  const { effects, semanticColors } = useTheme();

  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          WebkitFontSmoothing: `antialiased`,
          backgroundColor: semanticColors.cardStandoutBackground,
          border: `1px solid ${semanticColors.bodyFrameDivider}`,
          borderRadius: effects.roundedCorner4,
          boxShadow: effects.elevation8,
          height: `210px`,
          position: `relative`,
          userSelect: `none`,
          width: `330px`,
          selectors: {
            ":focus": {
              outline: `0px solid`
            }
          }
        }
      ]
    }),
    [effects, semanticColors]
  );
}
